import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreateZoneModalSchema, ZoneBasics, createZoneSteps } from '../types';

const initialState: CreateZoneModalSchema = {
  isOpened: false,
  steps: createZoneSteps,
  basics: null,
  selectedBoxIds: [],
  selectedDoorIds: [],
  selectedUserIds: [],
};

const createZoneModalSlice = createSlice({
  name: 'createZoneModal',
  initialState,
  reducers: {
    setOpened: (state, action: PayloadAction<boolean>) => {
      state.isOpened = action.payload;
    },

    changeStepData: (state, action: PayloadAction<{ targetStepIndex: number; stepData: string }>) => {
      state.steps = state.steps.map((step, index) =>
        index === action.payload.targetStepIndex ? { ...step, stepData: action.payload.stepData } : step,
      );
    },

    setBasics: (state, action: PayloadAction<ZoneBasics>) => {
      state.basics = action.payload;
    },

    setSelectedBoxIds: (state, action: PayloadAction<string[]>) => {
      state.selectedBoxIds = action.payload;
    },

    setSelectedDoorIds: (state, action: PayloadAction<string[]>) => {
      state.selectedDoorIds = action.payload;
    },

    setSelectedUserIds: (state, action: PayloadAction<string[]>) => {
      state.selectedUserIds = action.payload;
    },

    resetModalState: (state) => {
      state.isOpened = false;
      state.basics = null;
      state.selectedBoxIds = [];
      state.selectedUserIds = [];
      state.steps = createZoneSteps;
    },
  },
});

export const { actions: createZoneModalActions, reducer: createZoneModalReducer } = createZoneModalSlice;
